var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProductInfoEnabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "22px",
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/product-info/shown",
    transform: "translate(-8.000000, -6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    fill: "#5C7284",
    x: 0,
    y: 0,
    width: 16,
    height: 20,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3785235,2 C13.452349,2 14,2.57681325 14,3.70188464 L14,3.70188464 L14,10.2924043 C14,11.4231868 13.452349,12 12.3785235,12 L12.3785235,12 L3.62147651,12 C2.54765101,12 2,11.4231868 2,10.2924043 L2,10.2924043 L2,3.70188464 C2,2.57110223 2.54765101,2 3.62147651,2 L3.62147651,2 Z M6.32806396,6.36981201 L3,8.97891317 L3,10.0693761 C3,10.6338699 3.23156952,11 3.71851153,11 L3.71851153,11 L12.295848,11 C12.7774972,11 13,10.6338699 13,10.0693761 L13,10.0693761 L13,9.11544247 L11.9877739,8.23248291 C11.2217913,8.8420432 10.7536892,9.22471777 10.5834674,9.3805066 C10.3281347,9.61418985 10.1540851,9.61418985 9.88925368,9.3805066 C9.7126994,9.22471777 8.52563616,8.2211529 6.32806396,6.36981201 L6.32806396,6.36981201 Z M12.2930405,3 L3.72824192,3 C3.24154552,3 3,3.23792664 3,3.71377992 L3,3.71377992 L3,7.6015625 C4.76560754,6.26236288 5.73402245,5.52851638 5.90524474,5.40002301 C6.16207817,5.20728296 6.55832197,5.20728296 6.82224046,5.40002301 C6.99818612,5.52851638 8.12474073,6.43987346 10.2019043,8.13409424 C11.0552003,7.41246941 11.5495658,7.00742931 11.6850007,6.91897394 C11.8881529,6.78629089 12.111376,6.76415638 12.2930405,6.91897394 C12.4141502,7.02218565 12.6498034,7.20415645 13,7.46488635 L13,7.46488635 L13,3.71377992 C13,3.23792664 12.7744467,3 12.2930405,3 L12.2930405,3 Z M10.0001495,4 C10.5515179,4 11,4.448473 11,5 C11,5.55137656 10.5515179,6 10.0001495,6 C9.44863167,6 9,5.55137656 9,5 C9,4.448473 9.44863167,4 10.0001495,4 Z",
    id: "image-icon",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 2,
    y: 13,
    width: 12,
    height: 1.5,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    fill: "#FFFFFF",
    x: 2,
    y: 16,
    width: 12,
    height: 1.5,
    rx: 0.75
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductInfoEnabled);
export default __webpack_public_path__ + "static/media/icon_product_info_enabled.b9eb740e.svg";
export { ForwardRef as ReactComponent };